import { $fetch } from "ofetch";
import { defineStore, useRuntimeConfig } from '#imports';

export const useApiStore = defineStore('api', {
  actions: {
    async getData (url: string) {
      const config = useRuntimeConfig();

      return await $fetch(`${config.public.baseUrl}${url}`);
    },
    async postData (url: string, data) {
      const config = useRuntimeConfig();

      return await $fetch(`${config.public.baseUrl}${url}`, {
        method: 'POST',
        body: data,
      });
    },
  },
})